module.exports = __webpack_public_path__ + "img/dreamroom_preview.e7f1d1c3.jpg";